<mat-card class="card">
  <mat-card-header>
    <h3 mat-card-title>{{ 'Data Protection' | translate }}</h3>
    <button mat-button ixTest="create-snapshot" (click)="addSnapshot()">
      {{ 'Create Snapshot' | translate }}
    </button>
  </mat-card-header>
  <mat-card-content>
    <div class="details-item">
      <div class="label">{{ 'Total Snapshots' | translate }}:</div>
      <div class="total-snapshots value">{{ dataset.snapshot_count }}</div>
      <a class="action" ixTest="manage-snapshots" [routerLink]="['/datasets/snapshots', dataset.id]">
        {{ 'Manage Snapshots' | translate }}
      </a>
    </div>
    <div class="details-item">
      <div class="label">{{ 'Snapshot Tasks' | translate }}:</div>
      <div class="snapshot-tasks value">{{ dataset.snapshot_tasks_count }}</div>
      <a
        class="action"
        ixTest="manage-snapshot-tasks"
        [routerLink]="['/data-protection/snapshot', dataset.id]"
      >
        {{ 'Manage Snapshot Tasks' | translate }}
      </a>
    </div>
    <div class="details-item">
      <div class="label">{{ 'Replication Tasks' | translate }}:</div>
      <div class="replication-tasks value">
        {{ dataset.replication_tasks_count }}
      </div>
      <a
        class="action"
        ixTest="manage-replication-tasks"
        [routerLink]="['/data-protection/replication', dataset.id]"
      >
        {{ 'Manage Replication Tasks' | translate }}
      </a>
    </div>
    <div class="details-item">
      <div class="label">{{ 'Cloud Sync Tasks' | translate }}:</div>
      <div class="cloudsync-tasks value">
        {{ dataset.cloudsync_tasks_count }}
      </div>
      <a
        class="action"
        ixTest="manage-cloudsync-tasks"
        [routerLink]="['/data-protection/cloudsync', dataset.id]"
      >
        {{ 'Manage Cloud Sync Tasks' | translate }}
      </a>
    </div>
    <div class="details-item">
      <div class="label">{{ 'Rsync Tasks' | translate }}:</div>
      <div class="rsync-tasks value">{{ dataset.rsync_tasks_count }}</div>
      <a class="action" ixTest="manage-rsync-tasks" [routerLink]="['/data-protection/rsync', dataset.id]">
        {{ 'Manage Rsync Tasks' | translate }}
      </a>
    </div>
  </mat-card-content>
</mat-card>
